var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habit"},[_c('habit-tab'),_c('habit-list',{staticClass:"layout-habit-list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }